import React, { useState, useRef, useEffect } from "react";
import AddVector from "../../assets/Icons/Add Vector.png";
import { ICONS } from "../../assets/Icons";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Swal from "sweetalert2";
import SuccessModal from "../successModal/successModal";
import useExcelDownloader from "../../Hooks/useExcelDownloader";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";

const VegaahUploadReportModal = ({
  show,
  handleClose,
  callApi,
  activeTab,
  setIsBulkUpload,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { downloadExcel } = useExcelDownloader();
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [csvFile, setCsvFile] = useState(null);

  const [formData, setFormData] = useState({
    username: loggedInUserName,
  });
  const [errors, setErrors] = useState({
    senderId: "",
    entityId: "",
    templateId: "",
    csv: "",
  });

  const handleAddUser = (e) => {
    e.preventDefault();

    handleCsvBulkUpload();
  };

  const handleBack = () => {
    handleClose();
    haldleSetEmptyField();
  };

  const haldleSetEmptyField = () => {
    setFormData({
      username: "",
    });
    setCsvFile(null);
    setErrors({});
  };

  const headers = [
    { key: "SrNo", label: "SrNo" },
    { key: "MobileNo", label: "MobileNumber" },
  ];

  const data = [{ SrNo: "", MobileNo: "", Template: "" }];

  const handelDownloadExcelFormat = () => {
    downloadExcel(data, headers, "BulkMessageFormat.xlsx");
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    setCsvFile(e.target.files[0]);
    // setBulkFileName(e.target.files[0]);
    // setIsBulkUpload(true);
    setErrors({});
  };

  const bulkUpload = async (payload) => {
    setLoading(true);
    try {
      // Make the API call
      const response = await axiosPostApi(
        apiList.VEGAAH_REPORT_UPLOAD,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.status === 200 && response?.data?.respCode === "00") {
        setShowSuccessModal(true);
        haldleSetEmptyField();
        setsuccessMessage(response?.data?.message);
        // setIsBulkUpload(true);
        // callApi();
        // handleClose();
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

    const handleCsvBulkUpload = () => {
    if (!csvFile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        csv: "Please select a CSV file before uploading.",
      }));
      return;
    }
    const formDataA = new FormData();
    formDataA.append("username", loggedInUserName);
    formDataA.append("file", csvFile);

    try {
      bulkUpload(formDataA);
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    handleClose(false);
  };

  // const isDisabled = !senderIdValue || !entityIdValue || !templateIdValue;
  const isDisabled = false;

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between gap-3 mb-2">
                <div className="flex items-center gap-3">
                  <img src={AddVector} alt="add vector" className="h-[40px]" />
                  <h5 className="modal-title main-title font-semibold">Upload Report</h5>
                </div>

                {/* Right section (close button) */}
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>

              <form onSubmit={(e) => handleAddUser(e)}>
                <div
                  className="scoped-modal modal-body"
                >
                  <div className="row mb-3">
                    <div
                      className="col-md-6"
                      style={{ width: "95%", marginTop: "24px" }}
                    >
                      <div
                        style={{
                          borderRadius: "10px",
                          border: "1px dashed #FF702B",
                          padding: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#F6F6F6",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          opacity: isDisabled ? 0.6 : 1,
                        }}
                        onClick={!isDisabled ? triggerFileInput : undefined}
                      >
                        <div>
                          <p
                            style={{
                              margin: 0,
                              color: "#454545",
                              fontSize: "16px",
                            }}
                          >
                            Upload from your computer
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "12px",
                              color: "#6D6D6D",
                            }}
                          >
                            .XLSX files <br />
                            <span>{csvFile?.name}</span>
                          </p>
                        </div>
                        <img
                          src={ICONS.UploadCsvIcon}
                          alt="uploadCsv"
                          style={{ width: "31px" }}
                        />
                        <input
                          type="file"
                          accept=".xlsx"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          className="hidden"
                          style={{ display: "none" }}
                        />
                      </div>
                      {errors.csv ? (
                        <span className="error">{errors.csv}</span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-[8px] w-[150px] h-[40px] font-semibold"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit !rounded-[8px] w-[150px] h-[40px]  font-semibold"
                    style={{
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    disabled={isDisabled}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
          {showSuccessModal && (
            <SuccessModal
              show={showSuccessModal}
              handleClose={handleCloseModal}
              successMessage={successMessage}
            />
          )}
        </div>
      )}
    </>
  );
};

export default VegaahUploadReportModal;
